/**
 * 批量操作
 */
const batchOperation = {
    namespaced: true,
    state: {
        selectedCards: [],
        checkedAmount: 0
    },
    action: {},
    mutations: {
        addSelectedCards(state, cardData) {
            state.selectedCards.push(cardData);
        },
        delSelectedCards(state, cardData) {
            for (let i = 0; i < state.selectedCards.length; i++) {
                if (state.selectedCards[i].fileId === cardData.fileId) {
                    state.selectedCards.splice(i, 1);
                }
            }
        },
        delAllSelectedCards(state) {
            state.selectedCards.length = 0;
        },
        updateCheckedAmount(state, isAdd = true) {
            if (isAdd) {
                state.checkedAmount++;
            } else {
                state.checkedAmount--;
            }
        }
    }
};

export default batchOperation;
